import { FrontendUserInfo } from "node-library/dist/portal";

interface Props {
	label: string;
	icon: React.ReactNode;
	isExpanded: boolean;
	isMobile: boolean;
	selected: boolean;
	onClick: () => void;
}

export default function SidebarRow(props: Props) {
	return (
		<>
			{props.isMobile && !props.isExpanded ? (
				<> </>
			) : (
				<div
					className={`sidebar-action-row ${
						props.selected ? "sidebar-action-row-selected" : ""
					}`}
					onClick={props.onClick}
				>
					<div
						className={`sidebar-action-row-image-container ${
							props.selected ? "sidebar-action-image-selected" : ""
						}`}
					>
						{props.icon}
					</div>
					<div
						className={`sidebar-action-row-text typography-body-02 ${
							props.isExpanded ? `` : `sidebar-collapse-hide`
						}`}
					>
						{props.label}
					</div>
				</div>
			)}
		</>
	);
}
